import axios from 'axios';
import { initialize } from 'redux-form';
import consts from '../consts';
import { setErroAPI, setSuccess, setError } from '../common/toast/toast';

const somenteData = valor => (valor || '').split('T')[0].split(' ')[0].replace(/\//g, '-');

const ordenarProducoes = lista => [...(lista || [])].sort((a, b) => {
	const ordemA = a.ordem == null ? Number.MAX_SAFE_INTEGER : Number(a.ordem);
	const ordemB = b.ordem == null ? Number.MAX_SAFE_INTEGER : Number(b.ordem);

	if (ordemA !== ordemB) {
		return ordemA - ordemB;
	}

	return Number(a.id) - Number(b.id);
});

function validar(registro, listaProducoes) {

	if (!registro.data_agendamento) {
		setError('Informe a data da carga.');
		return false;
	}

	if (!(registro.producoes || []).length) {
		setError('Selecione pelo menos uma produção para a carga.');
		return false;
	}

	const dataCarga = somenteData(registro.data_agendamento);
	const producoesDia = ordenarProducoes((listaProducoes || []).filter(item => (
		somenteData(item.data_agendamento) === dataCarga
	)));
	const idsSelecionados = (registro.producoes || []).map(item => String(item.id_producao));
	const posicoes = idsSelecionados.map(id => (
		producoesDia.findIndex(item => String(item.id) === id)
	));

	if (posicoes.some(posicao => posicao < 0)) {
		setError('Todas as produções da carga devem pertencer ao dia selecionado.');
		return false;
	}

	const posicoesOrdenadas = [...posicoes].sort((a, b) => a - b);
	const sequenciais = posicoesOrdenadas.every((posicao, indice) => (
		indice === 0 || posicao === posicoesOrdenadas[indice - 1] + 1
	));

	if (!sequenciais) {
		setError('As produções da carga devem ser consecutivas na ordem do dia.');
		return false;
	}

	return true;
}

export function setModoTela(modo, registro = {}) {
	return {
		type: 'CARGA_MODO_TELA',
		payload: {
			modo,
			registro
		}
	};
}

export function setAguardando(aguardando) {
	return {
		type: 'CARGA_SET_AGUARDANDO',
		payload: aguardando
	};
}

export function setFiltro(filtro) {
	return {
		type: 'CARGA_SET_FILTRO',
		payload: filtro
	};
}

export function initForm(registro = {}) {
	return [initialize('cargaForm', registro)];
}

export function getLista() {
	return dispatch => {
		dispatch(setAguardando(true));

		return axios.get(`${consts.API_URL}/carga`)
			.then(resp => {
				dispatch({
					type: 'CARGA_LISTADO',
					payload: resp
				});
			})
			.catch(e => setErroAPI(e))
			.finally(() => dispatch(setAguardando(false)));
	};
}

export function getListaProducoes(data) {
	return dispatch => {
		if (!data) {
			dispatch({
				type: 'CARGA_PRODUCAO_LISTADO',
				payload: { data: [] }
			});
			return Promise.resolve();
		}

		dispatch(setAguardando(true));

		return axios.get(`${consts.API_URL}/producao?data_agendamento=${encodeURIComponent(data)}`)
			.then(resp => {
				dispatch({
					type: 'CARGA_PRODUCAO_LISTADO',
					payload: resp
				});
			})
			.catch(e => setErroAPI(e))
			.finally(() => dispatch(setAguardando(false)));
	};
}

export function getHistoricoProducao(idCarga) {
	return dispatch => {
		dispatch(setAguardando(true));

		return axios.get(`${consts.API_URL}/producaoCarga/historico?id_carga=${idCarga}`)
			.then(resp => {
				dispatch({
					type: 'CARGA_HISTORICO_PRODUCAO_LISTADO',
					payload: {
						idCarga,
						lista: resp.data
					}
				});
			})
			.catch(e => setErroAPI(e))
			.finally(() => dispatch(setAguardando(false)));
	};
}

export function limparHistoricoProducao() {
	return {
		type: 'CARGA_HISTORICO_PRODUCAO_LIMPAR'
	};
}

export function salvar(registro, onSuccess) {
	return (dispatch, getState) => {
		if (registro.id && !(registro.producoes || []).length) {
			dispatch(setAguardando(true));

			return axios.delete(`${consts.API_URL}/carga?id=${registro.id}`)
				.then(() => {
					setSuccess('Carga cancelada porque todas as produções foram removidas.');
					dispatch(getLista());
					dispatch(setModoTela('lista'));
					if (onSuccess) {
						onSuccess();
					}
				})
				.catch(e => setErroAPI(e))
				.finally(() => dispatch(setAguardando(false)));
		}

		if (!validar(registro, getState().carga.listaProducoes)) {
			return;
		}

		dispatch(setAguardando(true));
		const requisicao = registro.id
			? axios.put(`${consts.API_URL}/carga`, registro)
			: axios.post(`${consts.API_URL}/carga`, registro);

		return requisicao
			.then(() => {
				setSuccess('Carga salva com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
				if (onSuccess) {
					onSuccess();
				}
			})
			.catch(e => {
				if (e && e.response && e.response.status === 409 && e.response.data instanceof Array) {
					e.response.data.forEach(item => setError(item.msg || item));
				} else {
					setErroAPI(e);
				}
			})
			.finally(() => dispatch(setAguardando(false)));
	};
}

export function excluir(registro) {
	return dispatch => {
		dispatch(setAguardando(true));

		return axios.delete(`${consts.API_URL}/carga?id=${registro.id}`)
			.then(() => {
				setSuccess('Carga excluída com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			})
			.catch(e => setErroAPI(e))
			.finally(() => dispatch(setAguardando(false)));
	};
}
